import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

const LeftMenu = ({ currentPage }) => (
  <div className="col-md-5 col-lg-4 mb-4">
    <aside className="im-left-menu">
      <nav className="im-content-nav">
        <Link href="/content/buying/before-bidding">
          <a className={`im-content-nav__item ${currentPage === 'before-bidding' ? 'im-content-nav__item--active' : ''}`}>Teklif Vermeden Önce Okunması Gerekenler</a>
        </Link>
        <Link href="/content/buying/auction-process">
          <a className={`im-content-nav__item ${currentPage === 'auction-process' ? 'im-content-nav__item--active' : ''}`}>Açık Artırma Nedir?</a>
        </Link>
        <Link href="/content/buying/auction-methods">
          <a className={`im-content-nav__item ${currentPage === 'auction-methods' ? 'im-content-nav__item--active' : ''}`}>Açık Artırma Yöntemleri</a>
        </Link>
        <Link href="/content/buying/buy-now-process">
          <a className={`im-content-nav__item ${currentPage === 'buy-now-process' ? 'im-content-nav__item--active' : ''}`}>Hemen Al Süreci</a>
        </Link>
        <Link href="/content/buying/assurance-of-iyimakina">
          <a className={`im-content-nav__item ${currentPage === 'assurance-of-iyimakina' ? 'im-content-nav__item--active' : ''}`}>iyiMakina.com Güvencesi</a>
        </Link>
        <Link href="/content/buying/process-of-buying">
          <a className={`im-content-nav__item ${currentPage === 'process-of-buying' ? 'im-content-nav__item--active' : ''}`}>Satın Alma Süreci</a>
        </Link>
        <Link href="/content/buying/payment-process">
          <a className={`im-content-nav__item ${currentPage === 'payment-process' ? 'im-content-nav__item--active' : ''}`}>Ödeme Süreci</a>
        </Link>
        <Link href="/content/buying/shipping-and-delivery-process">
          <a className={`im-content-nav__item ${currentPage === 'shipping-and-delivery-process' ? 'im-content-nav__item--active' : ''}`}>Nakliye ve Teslimat Süreci</a>
        </Link>
      </nav>
    </aside>
  </div>
);

LeftMenu.propTypes = {
  currentPage: PropTypes.string,
};

export default LeftMenu;
